import Vue from 'vue'
import Router from 'vue-router'

const routes = [
  {
    path: '/errors',
    component: () => import('./components/BaseLayout'),
    children: [
      {
        path: '401',
        name: '401',
        component: () => import('./views/Error401')
      },
      {
        path: '403',
        name: '403',
        component: () => import('./views/Error403')
      },
      {
        path: '404',
        name: '404',
        component: () => import('./views/Error404')
      },
      {
        path: '500',
        name: '500',
        component: () => import('./views/Error500')
      },
      {
        path: '503',
        name: '503',
        component: () => import('./views/Error503')
      }
    ]
  }
]

Vue.use(Router)

export const router = new Router({ routes })
